type MetricShape = {
  engagement?: number | null,
  engagementRate?: number | null,
  followers?: number | null
} | Array<{name: string, value: string}>

export function isMetricsStillFetching(metrics?: MetricShape): boolean {
  if (metrics instanceof Array) {
    const engagement = metrics.find(metric => metric.name === 'engagement')?.value;
    const followers = metrics.find(metric => metric.name === 'num_followers')?.value;
    return !engagement && !followers;
  }

  return !metrics
    || (
      !metrics.engagement && !metrics.followers && !metrics.engagementRate
    );
}
